import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import 'vue3-carousel/dist/carousel.css'
import VueEasyLightbox from 'vue-easy-lightbox'
import VueGtag from 'vue-gtag'



createApp(App).use(store).use(router).use(VueGtag, {
    config: { id: "G-JL2JMPR33Y" }
  }).use(VueEasyLightbox).mount('#app')